import env from 'env.js';
import React from 'react';
import _ from 'lodash';
import { lbl } from '../../utils/intl';

export class BaseComponent extends React.PureComponent {
  constructor(props, state) {
    super(props);
    this.state = state || {};
    this._timeouts = [];
    this._callbacks = [];
  }

  callback(cb) {
    return function() {
      //cancel any execution when the component is not mounted
      if (this._unmounted) return;
      cb.apply(null, arguments);
    }.bind(this);
  }

  to(url, newWindow) {
    //
    if (newWindow) {
      window.open(url);
    } else {
      this.props.history.push(url);
    }
  }

  tofn(url) {
    return event => {
      this.to(url, event?.ctrlKey || event?.metaKey);
    };
  }

  setStateFn(val) {
    return () => {
      this.setState(val);
    };
  }

  env(str, def) {
    return str in env ? env[str] : def;
  }

  lbl(str) {
    return lbl(str);
  }

  lblStr(id) {
    return this.props.intl.formatMessage({ id });
  }

  componentWillUnmount() {
    this._unmounted = true;

    _.forEach(this._timeouts, t => clearTimeout(t));

    this._timeouts = null;
  }

  timeout(fn, ms, clear) {
    if (clear) clearTimeout(clear);
    let t = setTimeout(fn, ms);
    this._timeouts.push(t);
    return t;
  }

  updateState(prop, value) {
    if (_.isObject(prop) && value === undefined) {
      this.setState({ ...(this.state || {}), ...prop });
      return this;
    }

    let state = this.state || {};
    this.setState({ ...state, [prop]: value });
    return this;
  }

  onInputChange(evt) {
    this.updateState(evt.target.name, evt.target.value);
  }

  navTo(path) {
    this.props.history.push(path);
  }
}
